<template>
  <div class="pagebox">
    <div class="toolbox">
      <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
    </div>
    <div>
      <el-table border :data="tableList">
        <el-table-column label="模板名称" prop="name" align="center" width="200"></el-table-column>
        <el-table-column label="限购区域" align="center" min-width="200">
          <template slot-scope="scope">
            <span v-for="(val, index) in scope.row.restrictionAreas" :key="index">{{ val.areaName }},</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="scope">
            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
              @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
      </el-pagination>
    </div>
    <!-- 区域限购配置 -->
    <el-dialog title="区域限购配置" :visible.sync="areaSetFormVisible" append-to-body :close-on-click-modal="false"
      width="50%">
      <div class="col">
        <el-button @click="allSelArea" size="small" type="primary">全选
        </el-button>
        <el-button @click="clearSelArea" size="small" type="danger">清除
        </el-button>
      </div>
      <el-form>
        <el-form-item label="模板名称" label-width="80px">
          <el-input v-model="formTemplate.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-tree style="height:400px;overflow:auto;" :data="areaTreeList" show-checkbox
            :default-expanded-keys="defaultExpandedKeys" node-key="id" ref="trees" highlight-current :accordion="true" v-if="areaSetFormVisible">
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="areaSetFormVisible = false, areaList = []">取消</el-button>
        <el-button type="primary" @click.native="submitAreaSet" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../../promissionRouter";
import toolbar from "../../../components/Toolbar";
import {
  RestrictionAreaGroupCreate,
  RestrictionAreaGroupUpdate,
  RestrictionAreaGroupDelete,
  RestrictionAreaGroupGet,
  RestrictionAreaGroupGetAll,
  GetAreaTree
} from '../../../api/api'
export default {
  components: {
    toolbar
  },
  data() {
    return {
      total: 0,
      tableList: [],
      searchData: {
        name: null,
        includingItems: true,
        isActive: true,
        beginCreateTime: null,
        endCreateTime: null,
        skipCount: 0,
        maxResultCount: 10
      },
      pageIndex: 1,
      pageSize: 10,
      buttonList_toolBar: [],
      buttonList_table: [],
      areaSetFormVisible: false,
      areaTreeList: [],
      submitLoading: false,
      formTemplate: {
        name: null,
        isActive: true,
        restrictionAreas: []
      },
      defaultExpandedKeys: []
    }
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.buttonShow === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;
    const tableButtonList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableButtonList;
  },
  mounted() {
    this.getTableData()
    this.renderAreaTree()
  },
  methods: {
    createdBtn() {
      this.areaSetFormVisible = true
    },
    allSelArea() {
      this.$refs.trees.setCheckedNodes(this.areaTreeList);
    },
    clearSelArea() {
      this.$refs.trees.setCheckedNodes([]);
    },
    renderAreaTree() {
      let params = {
        MaxLevel: 2
      };
      GetAreaTree(params).then((res) => {
        this.areaTreeList = this.loopTree(res.data.result.children);
      });
    },
    loopTree(treeList, lastFullId) {
      const newList = treeList.filter(item => {
        let Level = item.data.Level;
        item.Level = Level;
        item.areaId = item.data.Id;
        item.areaName = item.data.Name;
        item.id = item.data.Id;
        item.label = item.data.Name;
        let nowFullId;
        if (Level == 1) nowFullId = '' + item.data.Id;
        if (Level == 2) nowFullId = [item.data.ParentId, item.data.Id].join(",");
        if (Level == 3) nowFullId = lastFullId + ',' + item.data.Id;
        item.areaFullId = nowFullId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopTree(item.children, item.areaFullId)
        }
        return true;
      })
      return newList;
    },
    submitAreaSet() {
      let checkedNodes = this.$refs.trees.getCheckedNodes(false, false);
      var newObject = JSON.parse(JSON.stringify(checkedNodes));
      newObject.forEach(x => {
        if (x.children) {
          delete x.children
        }
      })
      this.formTemplate.restrictionAreas = newObject
      console.log(newObject, 'newObject')
      // return false
      // this.checkedNodeList = newObject;
      // let params = {
      //   warehouseId: this.currentRow.id,
      //   deliveryAreas: this.checkedNodeList
      // };
      this.tableLoading = true;
      if (this.formTemplate.id) {
        RestrictionAreaGroupUpdate(this.formTemplate).then((res) => {
          this.tableLoading = false;
          if (res.data.success) {
            this.$message.success('提交成功');
            this.areaSetFormVisible = false;
            this.getTableData();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        RestrictionAreaGroupCreate(this.formTemplate).then((res) => {
          this.tableLoading = false;
          if (res.data.success) {
            this.$message.success('提交成功');
            this.areaSetFormVisible = false;
            this.getTableData();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    editBtn(item, index, row) {
      this.defaultExpandedKeys = []
      this.areaSetFormVisible = true;
      RestrictionAreaGroupGet({ id: row.id }).then(res => {
        if (res.data.success) {
          this.formTemplate = res.data.result
          let checkdKeys = [];
          res.data.result.restrictionAreas.forEach(x => {
            checkdKeys.push(x.areaId);
          })
          console.log(checkdKeys, 'checkdKeys')
          this.defaultExpandedKeys = checkdKeys
          this.defaultChecked(checkdKeys);
        }
      })
    },
    defaultChecked(keys) { // 默认选中
      this.$nextTick(() => {
        const arr = []
        keys.forEach(key => {
          if (!this.$refs.trees.getNode(key).childNodes || !this.$refs.trees.getNode(key).childNodes.length) {
            arr.push(key)
          }
        })
        this.$refs.trees.setCheckedKeys(arr)
      })
    },
    deleteBtn(item, index, row) {
      this.$confirm("确认删除该吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        RestrictionAreaGroupDelete(params).then((res) => {
          this.tableLoading = false;
          if (res.data.success) {
            this.$message.success('删除成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
      });
    },
    getTableData() {
      // this.loading = true
      this.searchData.skipCount = (this.pageIndex - 1) * this.pageSize
      this.searchData.maxResultCount = this.pageSize
      RestrictionAreaGroupGetAll(this.searchData).then(res => {
        if (res.data.success) {
          this.tableList = res.data.result.items || []
          this.total = res.data.result.totalCount || 0
        } else {
          this.$message.error(res.data.error.message)
        }
        // setTimeout(() => {
        //   this.loading = false
        // }, 500)
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getTableData()
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
  }
}
</script>

<style scoped>
.pagebox {
  padding: 0 20px;
}

.toolbox {
  text-align: right;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}
</style>